import React, { useEffect, useState } from "react";
import { Form, Row, Col, Spin, Result, Button, Modal } from "antd";
import { InputItem } from "../../../components/forms/FormItems";
import ReadOnlyItem from "../../../components/forms/ReadOnlyItem";
import AutoCompleteItem from "../../../components/forms/AutoCompleteItem";
import RestrictedContext from "../../../components/util/RestrictedContext";
import PhoneNumberItem from "../../../components/forms/PhoneNumberItem";
import SwitchItem from "../../../components/forms/SwitchItem";
import Centered from "../../../components/layouts/Centered";
import Surface from "../../../components/layouts/Surface";
import ContentHolder from "../../../components/layouts/ContentHolder";
import Spacer from "../../../components/layouts/Spacer";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useIntl } from "react-intl";
import FormHeader from "../../../components/forms/FormHeader";
import ResponsiveItemsWrapper from "../../../components/layouts/ResponsiveItemsWrapper";
import { useParams } from "react-router-dom";
import { getChangedItems } from "../../../components/util/helpers";
import FloatingFormActions from "../../../components/forms/FloatingFormActions";
import {
  deactivateRecord,
  activateRecord,
  isClientActive,
  setChangedFormItems,
  commitChanges,
} from "../clientDetailsSlice";
import { ServiceTypesSelect } from "../../../components/forms/AutoCompleteFormItem";
import { SettingsDataSelect } from "../../../components/forms/AutoCompleteFormItem";
import { isAllowedFeature } from "../../organization/organizationSlice";
import { FormattedMessage } from "react-intl";
import AnimationWrapper from "../../../components/animations/AnimationWrapper";
import { useClientCategories } from "../../../hooks";
import DetailsHeader from "../../../components/forms/DetailsHeader";
import { activationConfirmMessage } from "../../../components/forms/formsFeedback";
var flatten = require("flat");

const EditClientDetails = (props) => {
  const { readonly } = props;
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [isbtl, setIsBtl] = useState(null);
  const [isHolocastFund, setIsHolocastFund] = useState(null);
  const activeClient = useSelector((state) => state.clientDetails.activeClient);
  const changedItems = useSelector(
    (state) => state.clientDetails.changedItems.changed
  );
  const fetchLoading = useSelector(
    (state) => state.pendingActions["clientDetails/loadClient"]
  );
  const saveLoading = useSelector(
    (state) => state.pendingActions["clientDetails/update"]
  );
  const is_revaha = activeClient?.category?.revaha;
  let history = useHistory();
  const intl = useIntl();
  let { id, branchId } = useParams();
  const clientCategories = useClientCategories();
  const [modal, contextHolder] = Modal.useModal();
  useEffect(() => {
    if (activeClient.id) {
      const flat = flatten(activeClient, { safe: true });
      setIsBtl(activeClient.social_security);
      setIsHolocastFund(activeClient.holocast_fund);
      form.setFieldsValue(flat);
    }
  }, [activeClient, form, history, clientCategories]);

  const onDecline = () => {
    history.goBack();
  };

  const onActivate = (checked) => {
    activationConfirmMessage(
      activeClient,
      intl,
      checked,
      activeClient.name,
      "clients",
      onConfirm,
      modal
    );
  };

  const onConfirm = async () => {
    const params = { branchId: branchId, id: [parseInt(id)] };
    const toDispatch = isClientActive(activeClient, +branchId)
      ? deactivateRecord
      : activateRecord;
    const action = await dispatch(toDispatch(params));
    if (!action.error) {
      history.goBack();
    }
  };

  const onValuesChange = (changedValues, allValues) => {
    const arr = getChangedItems(
      changedValues,
      allValues,
      changedItems,
      activeClient
    );
    dispatch(setChangedFormItems({ changed: arr, values: allValues }));
  };

  const activeBaseTariffFilter = {
    $and: [
      {
        $or: activeClient.base_tariff_id
          ? [{ active: true }, { id: activeClient.base_tariff_id }]
          : [{ active: true }],
      },
    ],
  };

  const activeIncreaseTariffFilter = {
    $and: [
      {
        $or: activeClient.increased_tariff_id
          ? [{ active: true }, { id: activeClient.increased_tariff_id }]
          : [{ active: true }],
      },
    ],
  };

  const activeTariffFilter = {
    $and: [
      {
        $or: [{ active: true }],
      },
    ],
  };

  return fetchLoading ? (
    <Centered style={{ height: "618px" }}>
      <Spin size="large" />
    </Centered>
  ) : activeClient.id !== undefined ? (
    <AnimationWrapper animation="fadeIn" duration={0.5} overflow={true}>
      {contextHolder}
      <RestrictedContext.Provider value={{ hasWritePermission: !readonly }}>
        <Form
          layout="vertical"
          onFinish={() => dispatch(commitChanges())}
          form={form}
          onValuesChange={onValuesChange}
        >
          <Surface>
            <DetailsHeader
              resource={"clients"}
              action={"editor"}
              editTitle={<FormattedMessage id="app.forms.clientDetailsTitle" />}
              hasSwitch={true}
              mode={"edit"}
              isActive={isClientActive(activeClient, +branchId)}
              onActivate={onActivate}
            />

            <Row>
              <Col xs={24} sm={24} md={24} lg={21} xl={15} xxl={10}>
                <ResponsiveItemsWrapper>
                  <div style={{ flex: 1 }}>
                    <ReadOnlyItem
                      content={
                        activeClient.category && activeClient.category.name
                      }
                      name="category_id"
                      category="client"
                    />
                  </div>
                  <Spacer horizontal={true} />
                  <div style={{ flex: 1 }}>
                    <InputItem name="name" required={true} category="client" />
                  </div>
                </ResponsiveItemsWrapper>

                {isbtl ? (
                  <ResponsiveItemsWrapper>
                    <div style={{ flex: 1 }}>
                      <ReadOnlyItem
                        content={
                          activeClient.specific_data
                            ? activeClient.specific_data.comittee_name
                            : ""
                        }
                        name="specific_data.comittee_name"
                        category="client"
                      />
                    </div>
                    <Spacer horizontal={true} />

                    <div style={{ flex: 1 }}>
                      <ReadOnlyItem
                        content={
                          activeClient.specific_data
                            ? activeClient.specific_data.comittee_number
                            : ""
                        }
                        name="specific_data.comittee_number"
                        category="client"
                      />
                    </div>
                  </ResponsiveItemsWrapper>
                ) : null}

                {isbtl ? (
                  <ResponsiveItemsWrapper>
                    <div style={{ flex: 1 }}>
                      <ReadOnlyItem
                        content={
                          activeClient.specific_data
                            ? activeClient.specific_data
                                .organization_branch_name
                            : ""
                        }
                        name="specific_data.organization_branch_name"
                        category="client"
                      />
                    </div>
                    <Spacer horizontal={true} />

                    <div style={{ flex: 1 }}>
                      <ReadOnlyItem
                        content={
                          activeClient.specific_data
                            ? activeClient.specific_data
                                .organization_branch_number
                            : ""
                        }
                        name="specific_data.organization_branch_number"
                        category="client"
                      />
                    </div>
                  </ResponsiveItemsWrapper>
                ) : null}

                <ResponsiveItemsWrapper>
                  <div style={{ flex: 1 }}>
                    <InputItem
                      name="accounting_code"
                      category="client"
                      required={true}
                    />
                  </div>
                  <Spacer horizontal={true} />
                  <div style={{ flex: 1 }}>
                    <ServiceTypesSelect
                      mode="multiple"
                      name="service_types_ids"
                      category="client"
                    />
                  </div>
                </ResponsiveItemsWrapper>

                <ResponsiveItemsWrapper>
                  <div style={{ flex: 1 }}>
                    <InputItem name="debit_account_number" category="client" />
                  </div>
                  <Spacer horizontal={true} />
                  <div style={{ flex: 1 }}>
                    <InputItem name="credit_account_number" category="client" />
                  </div>
                </ResponsiveItemsWrapper>

                <ResponsiveItemsWrapper>
                  <div style={{ flex: 1 }}>
                    <InputItem
                      number={true}
                      name="business_id"
                      category="client"
                      min={1}
                    />
                  </div>
                  <Spacer horizontal={true} />
                  <div style={{ flex: 1 }}>
                    <SettingsDataSelect
                      name="contracts_ids"
                      category="client"
                      settingsdataName={"contracts"}
                      mode="multiple"
                      disabled={!isAllowedFeature("contracts")}
                    />
                  </div>
                </ResponsiveItemsWrapper>
                <ResponsiveItemsWrapper>
                  <div style={{ flex: 1 }}>
                    <InputItem
                      number={true}
                      name="btl_accounting_number"
                      category="client"
                    />
                  </div>
                  <Spacer horizontal={true} />
                  <div style={{ flex: 1 }}></div>
                </ResponsiveItemsWrapper>
                <ResponsiveItemsWrapper>
                  <div style={{ flex: 1 }}>
                    <SwitchItem
                      name="support_presense_reporting"
                      category="client"
                    />
                  </div>
                  <Spacer horizontal={true} />
                  <div style={{ flex: 1 }}>
                    {!isHolocastFund && !isbtl && (
                      <SwitchItem name="clalit" category="client" />
                    )}
                  </div>
                </ResponsiveItemsWrapper>
                {is_revaha && (
                  <ResponsiveItemsWrapper>
                    <div style={{ flex: 1 }}>
                      <SettingsDataSelect
                        name="client_frame_symbols_ids"
                        category="client"
                        settingsdataName={"client_frame_symbol"}
                        mode="multiple"
                        required={true}
                        type="list"
                      />
                    </div>
                    <Spacer horizontal={true} />
                    <div style={{ flex: 1 }}>
                      <SettingsDataSelect
                        name="client_tariff_symbols_ids"
                        category="client"
                        settingsdataName={"client_tariff_symbol"}
                        mode="multiple"
                        required={true}
                        type="list"
                      />
                    </div>
                  </ResponsiveItemsWrapper>
                )}

                <ResponsiveItemsWrapper>
                  <div style={{ flex: 1 }}>
                    <SettingsDataSelect
                      name="salary_settings.regular_hours_symbol_id"
                      category="client"
                      settingsdataName={"system_tables/salary/salary_symbols"}
                      paramName={"symbol"}
                    />
                  </div>
                  <Spacer horizontal={true} />
                  <div style={{ flex: 1 }}>
                    <SettingsDataSelect
                      name="salary_settings.saturday_hours_symbol_id"
                      category="client"
                      settingsdataName={"system_tables/salary/salary_symbols"}
                      paramName={"symbol"}
                    />
                  </div>
                </ResponsiveItemsWrapper>
                <ResponsiveItemsWrapper>
                  <div style={{ flex: 1 }}>
                    <SettingsDataSelect
                      name="salary_settings.extra_hours_rate1_symbol_id"
                      category="client"
                      settingsdataName={"system_tables/salary/salary_symbols"}
                      paramName={"symbol"}
                    />
                  </div>
                  <Spacer horizontal={true} />
                  <div style={{ flex: 1 }}>
                    <SettingsDataSelect
                      name="salary_settings.extra_hours_rate2_symbol_id"
                      category="client"
                      settingsdataName={"system_tables/salary/salary_symbols"}
                      paramName={"symbol"}
                    />
                  </div>
                </ResponsiveItemsWrapper>
                {/* <ResponsiveItemsWrapper>
                  <div style={{ flex: 1 }}>
                    <SettingsDataSelect
                      name="salary_settings.extra_hours_rate3_symbol_id"
                      category="client"
                      settingsdataName={"system_tables/salary/salary_symbols"}
                      paramName={"symbol"}
                    />
                  </div>
                  <Spacer horizontal={true} />
                  <div style={{ flex: 1 }}>
                    <SettingsDataSelect
                      name="salary_settings.extra_hours_rate4_symbol_id"
                      category="client"
                      settingsdataName={"system_tables/salary/salary_symbols"}
                      paramName={"symbol"}
                    />
                  </div>
                </ResponsiveItemsWrapper> */}
                <ResponsiveItemsWrapper>
                  <div style={{ flex: 1 }}>
                    <SettingsDataSelect
                      name="salary_settings.holiday_hours_symbol_id"
                      category="client"
                      settingsdataName={"system_tables/salary/salary_symbols"}
                      paramName={"symbol"}
                    />
                  </div>
                  <Spacer horizontal={true} />
                  <div style={{ flex: 1 }}>
                    <SettingsDataSelect
                      name="salary_settings.holiday_given_hours_symbol_id"
                      category="client"
                      settingsdataName={"system_tables/salary/salary_symbols"}
                      paramName={"symbol"}
                    />
                  </div>
                </ResponsiveItemsWrapper>
                <ResponsiveItemsWrapper>
                  <div style={{ flex: 1 }}>
                    <SettingsDataSelect
                      name="salary_settings.retro_hours_symbol_id"
                      category="client"
                      settingsdataName={"system_tables/salary/salary_symbols"}
                      paramName={"symbol"}
                    />
                  </div>
                  <Spacer horizontal={true} />
                  <div style={{ flex: 1 }}>
                    <SettingsDataSelect
                      name="base_tariff_id"
                      category="client"
                      settingsdataName={"client_tariffs"}
                      paramName={"cost"}
                      extraParams={{
                        filter: activeBaseTariffFilter,
                      }}
                      type="list"
                    />
                  </div>
                </ResponsiveItemsWrapper>

                <ResponsiveItemsWrapper>
                  <div style={{ flex: 1 }}>
                    <SettingsDataSelect
                      name="salary_tariff_id"
                      paramName={"cost"}
                      category="client"
                      settingsdataName={"tariffs"}
                      extraParams={{
                        filter: activeTariffFilter,
                      }}
                      type="list"
                    />
                  </div>
                  <Spacer horizontal={true} />
                  <div style={{ flex: 1 }}>
                    {isbtl && (
                      <SettingsDataSelect
                        name="increased_tariff_id"
                        category="client"
                        settingsdataName={"client_tariffs"}
                        extraParams={{
                          filter: activeIncreaseTariffFilter,
                        }}
                        type="list"
                      />
                    )}
                  </div>
                </ResponsiveItemsWrapper>
              </Col>
            </Row>
          </Surface>

          <Surface>
            <FormHeader
              title={<FormattedMessage id="app.forms.clientContactTitle" />}
            />
            <Row>
              <Col xs={24} sm={24} md={24} lg={21} xl={15} xxl={10}>
                <ResponsiveItemsWrapper>
                  <div style={{ flex: 1 }}>
                    <PhoneNumberItem name="phone_number" category="client" />
                  </div>
                  <Spacer horizontal={true} />

                  <div style={{ flex: 1 }}>
                    <PhoneNumberItem name="fax_number" category="client" />
                  </div>
                </ResponsiveItemsWrapper>

                <ResponsiveItemsWrapper>
                  <div style={{ flex: 1 }}>
                    <InputItem name="email" email={true} category="client" />
                  </div>
                  <Spacer horizontal={true} />

                  <div style={{ flex: 1 }}></div>
                </ResponsiveItemsWrapper>
              </Col>
            </Row>
          </Surface>

          <Surface>
            <FormHeader
              title={<FormattedMessage id="app.forms.clientAddressTitle" />}
            />
            <Row>
              <Col xs={24} sm={24} md={24} lg={21} xl={15} xxl={10}>
                <ResponsiveItemsWrapper>
                  <div style={{ flex: 1 }}>
                    <AutoCompleteItem
                      name="address.city"
                      category="client"
                      city={true}
                    />
                  </div>
                  <Spacer horizontal={true} />

                  <div style={{ flex: 1 }}>
                    <InputItem
                      name="address.postal_code"
                      postalCode={true}
                      category="client"
                    />
                  </div>
                </ResponsiveItemsWrapper>

                <ResponsiveItemsWrapper>
                  <div style={{ flex: 1 }}>
                    <InputItem name="address.street" category="client" />
                  </div>
                  <Spacer horizontal={true} />

                  <div style={{ flex: 1 }}>
                    <InputItem name="address.house_number" category="client" />
                  </div>
                </ResponsiveItemsWrapper>

                <ResponsiveItemsWrapper>
                  <div style={{ flex: 1 }}>
                    <InputItem name="mailbox_number" category="client" />
                  </div>
                  <Spacer horizontal={true} />

                  <div style={{ flex: 1 }}></div>
                </ResponsiveItemsWrapper>
              </Col>
            </Row>
          </Surface>
          <FloatingFormActions
            resource={"clients"}
            action={"editor"}
            onCancel={onDecline}
            mode={"edit"}
            onDecline={onDecline}
            hideDelete={true}
            hideDecline={true}
            saveLoading={saveLoading}
            saveText={intl.formatMessage({
              id: "app.actions.saveChanges",
            })}
            show={changedItems.length > 0}
          />
        </Form>
      </RestrictedContext.Provider>
    </AnimationWrapper>
  ) : (
    <ContentHolder>
      <Result
        status="warning"
        title={intl.formatMessage({
          id: "app.errors.failFetchClient",
        })}
        extra={
          <Button
            type="primary"
            key="clients"
            onClick={() => {
              history.goBack();
            }}
          >
            {intl.formatMessage({
              id: "app.actions.goToClients",
            })}
          </Button>
        }
      />
    </ContentHolder>
  );
};

export default EditClientDetails;
